<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :cell-style="bodyCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="alarmTriggerName" :label="$t('integration.trigger_name_')" show-overflow-tooltip />
        <el-table-column prop="sceneName" :label="$t('public.table_scope')" show-overflow-tooltip v-if="isSysAdmin"></el-table-column>
        <el-table-column :label="$t('integration.monitoring_point')" show-overflow-tooltip prop="carrierName" />
        <el-table-column :label="$t('integration.event')" show-overflow-tooltip prop="event">
            <template #default="{row}">
                <i class="cursor-pointer" :class="triggerEvent[row.event].icon" :title="$t(triggerEvent[row.event].title)"></i>
            </template>
        </el-table-column>
        <el-table-column :label="$t('integration.explain')" show-overflow-tooltip prop="reasonName" width="120px" />
        <el-table-column :label="$t('syslog.operator')" show-overflow-tooltip prop="operator" width="120px" />
        <el-table-column :label="$t('syslog.operation_time')" show-overflow-tooltip prop="createTime">
            <template #default="{ row }">{{ $timetransition(row.createTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('syslog.operation')" show-overflow-tooltip prop="operate" width="120px">
            <template #default="{ row }">
                <div class="uk-flex uk-flex-center">
                    <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.tbopt_detail')" v-has="['uptRange']" @click="detailFn(row)"></el-button>
                    <el-button @click="delsMonitor(row)" :title="$t('public.tbopt_delete')" icon="el-icon-delete" type="text" size="small" v-has="['delRange']"></el-button>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { triggerEvent } from '@/utils/convert';

export default {
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        },
        triggerEvent: () => triggerEvent
    },
    props: ['loading', 'tableData'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)'
        };
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
        },
        detailFn(row) {
            this.$emit('detailRow', row);
        },
        delsMonitor(row) {
            this.$emit('delRow', row);
        }
    }
};
</script>

<style></style>
